/* import __COLOCATED_TEMPLATE__ from './app-required.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();